<template>
	<a id="nav-toggle" role="button" tabindex="0" aria-label="Toggle menu">
		<span></span>
	</a>
</template>

<script>
	export default {

	}	
</script>

<style lang="scss">
	@import './../../variables.scss';

	#nav-toggle {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		width: 44px;
		height: 44px;
		border-radius: $radius-md;
		border: 1px solid $third;
	}

	#nav-toggle span,
	#nav-toggle span:before,
	#nav-toggle span:after {
		display: block;
		width: 22px;
		height: 2px;
		border-radius: 2px;
		background: $third;
	}
	#nav-toggle span {
		position: relative;
	}
	#nav-toggle span:before,
	#nav-toggle span:after {
		content: '';
		position: absolute;
		left: 0;
	}
	#nav-toggle span:before {
		top: -7px;
	}
	#nav-toggle span:after {
		top: 7px;
	}
</style>